import * as React from 'react'
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { adminIntrospectionQueriesAtom } from 'shared/api/adminIntrospection'

interface IQuery {
  name: string
  description: string
}

function QueryGroup({ queries, title }: { queries: IQuery[]; title: string }) {
  return (
    <Box>
      <p>{title}</p>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Description</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {queries.map((q) => {
            const desc = q.description.split(': ')[1]
            return (
              <TableRow key={q.name}>
                <TableCell size={'small'}>
                  <b>{q.name}</b>
                </TableCell>
                <TableCell size={'small'}>{desc}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </Box>
  )
}

export function AdminIntrospection() {
  const rootQueries = useAtomValue(adminIntrospectionQueriesAtom)
  return (
    <Box>
      <Box>Admin Queries</Box>
      <QueryGroup queries={rootQueries?.queries || []} title={'Queries'} />
      <QueryGroup queries={rootQueries?.mutations || []} title={'Mutations'} />
    </Box>
  )
}
